import { connect } from 'react-redux';
import {getTranslation} from "../../../reducers/common/localization";
import OrgFinanceManagement from "./OrgFinanceManagement";
import { getCurrentPresetData, getPresetsData, setCurrentPreset, getCurrentPresetId } from "../../../reducers/finance/finance";
import { getCurrenciesData, getConvertedMoney, fetchConvertMoney } from "../../../reducers/finance/currencies";
import { getOrgFinanceData, fetchUpdateOrgPrice } from "../../../reducers/organization/organizations";

const mapStateToProps = (state) => {
    return {
        convertedBalance: getConvertedMoney(state),
        data: getOrgFinanceData(state),
        currentPresetId: getCurrentPresetId(state),
        currentPresetData: getCurrentPresetData(state),
        presetsData: getPresetsData(state),
        currenciesData: getCurrenciesData(state),
        translation: getTranslation(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onChangePrice: (id, data) => dispatch(fetchUpdateOrgPrice(id, data)),
        onChangePreset: (id) => {
            dispatch(setCurrentPreset(id));
        },
        onConvertMoney: (data) => {
            dispatch(fetchConvertMoney(data));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(OrgFinanceManagement);



// WEBPACK FOOTER //
// ./src/components/organizationManagement/orgFinanceManagement/OrgFinanceManagement.container.js